module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAyCAMAAABmvHtTAAAAM1BMVEUAAAD////////////////////////////////////////////////////////qMTH1mJjQxDJoAAAADnRSTlMAvRDz2cWQXVE7A9aiod1KDT4AAACPSURBVCjPjdPbDoQgDEXRKeB1tNP//9pJjLamO1F4IawHwuWcz32UaZdWbzCLHsNhGY510DpecFERTVS+mmgVzTRqpkVBA2hWkICKgibSRhJSI1XSORvpZyS3ILcgtyC3ILdXso7treOo9njt2vWEQtq7Pq2QsBligjAhcgwm48uQv1WBhWGtWL5U0U1a/QN/EylLmbZ+NwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/right.png
// module id = arI+
// module chunks = 1